// extracted by mini-css-extract-plugin
module.exports = {"post-category":"PostCategory_post-category__X2aO8"};